// @ts-nocheck

import { createFileRoute } from "@tanstack/react-router";
import { Link, type LinkProps } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../db/db";
import CarePlan from "../../components/CarePlan";
import Attendance from "../../components/Forms/Attendance";
import { useState, useEffect } from "react";
import ClientPicker from "../../components/carePlan/ClientPicker";
import ClientProfile from "../../components/carePlan/ClientProfile";
import Tasks from "../../components/Forms/Tasks";
import ActivityForm from "../../components/Forms/ActivityForm";
import ActivityLogs from "../../components/Forms/ActivityLogs";
import IssueForm from "../../components/Forms/IssueForm";
import IssueLogs from "../../components/Forms/IssueLogs";
import IncidentForm from "../../components/Forms/IncidentForm";
import HandoverNotes from "../../components/Visit/HandoverNotes";
import RiskAssesments from "../../components/Visit/RiskAssessments";
import IncidentLogs from "../../components/Forms/IncidentLogs";
import ExpensesForm from "../../components/Forms/ExpensesForm";
import ExpenseLogs from "../../components/Forms/ExpenseLogs";
import BodyMapForm from "../../components/Forms/BodyMapForm";
import BodyMapLog from "../../components/Forms/BodyMapLog";
import BodyMapLogs from "../../components/Forms/BodyMapLogs";
import GenericForm from "../../components/GenericForms/Form";
import GenericForms from "../../components/GenericForms/Forms";
import FormResponses from "../../components/GenericForms/FormResponses";
import ClientInfo from "../../components/ClientInfo/ClientInfo";
import { Clock } from "lucide-react";
import TimeFromStart from "../../components/Visit/TimeFromStart";
import posthog from "posthog-js";
export const Route = createFileRoute("/visits/$visitId/details")({
  component: RouteComponent,
});

function RouteComponent() {
  const { selectedTab } = Route.useSearch();
  const [clients, setClients] = useState([]);
  const [clientIDs, setClientIDs] = useState([]);
  const [visitLength, setVisitLength] = useState();
  const [filteredCarePlans, setFilteredCarePlans] = useState([]);
  const [carePlan, setCarePlan] = useState();
  const [client, setClient] = useState();
  const { visitId } = Route.useParams();
  const [linkedRequirement, setLinkedRequirement] = useState(false);
  const navigate = useNavigate();
  const visit = useLiveQuery(() => db.visits.get(Number(visitId)));
  const [visitCompleted, setVisitCompleted] = useState(false);
  const [property, setProperty] = useState();
  const [propertySelected, setPropertySelected] = useState(false);
  const [tab, setTab] = useState("visit");


  // useEffect(() => {
  //   if (tab) {
  //     navigate({
  //       search: () => ({ selectedTab: tab }),
  //     });
  //   }
  // }, [tab]);

  // useEffect(() => {
  //   if (selectedTab) {
  //     setTab(selectedTab);
  //   }
  // }, [selectedTab]);
  useEffect(() => {
    if (visit) {
      if (visit["start_time"] && visit["finish_time"]) {
        const start = new Date(`1970-01-01T${visit["start_time"]}`);
        const end = new Date(`1970-01-01T${visit["finish_time"]}`);
        setVisitLength((end - start) / 3600000);
      }
    }
  }, [visit]);

const attendance = useLiveQuery(
  () => db.attendances.get(visit["id"]),
  [visit]
);


  const nextVisit = useLiveQuery(
    () =>
      db.visits
        .where("start_time")
        .above(visit["start_time"])
        .and((item) => item.linkedclients !== "")
        .first(),
    [visit]
  );
  const prevVisit = useLiveQuery(
    () =>
      db.visits
        .where("start_time")
        .below(visit["start_time"])
        .and((item) => item.linkedclients !== "")
        .first(),
    [visit]
  );
  

  useEffect(() => {
    if (visit) {
        posthog.capture("opened_visit", { 
          "visit_id": visit["id"],
          $set_once: { visit_id: visit["id"] },
        });
      if (visit["linkedclients"] !== "") {
        setClients(JSON.parse(visit["linkedclients"]));
      } else {
        navigate({
          to: "/visits",
        });
      }
      if (visit["propinfo"]) {
        setProperty(JSON.parse(visit["propinfo"]));
      }
    }
  }, [visit]);
  useEffect(() => {
    clients && setClientIDs(clients.map((client) => client[" clientid "]));
  }, [clients]);
  useEffect(() => {
    if (clientIDs && !client) {
      setClient(clientIDs[0]);
    }
    
  }, [clientIDs]);
  const carePlans = useLiveQuery(
    () => db.carePlans.bulkGet(clientIDs),
    [clientIDs]
  );
  useEffect(() => {
    if (carePlans) {
      setFilteredCarePlans(carePlans.filter((item) => item));
    }
  }, [carePlans]);
  useEffect(() => {
    if (client && filteredCarePlans) {
      setCarePlan(filteredCarePlans.find((item) => item["id"] == client));
    }
  }, [client, filteredCarePlans]);

  useEffect(() => {
    if (visit) {
      if (visit["for_req_id"]) {
        setLinkedRequirement(visit["for_req_id"]);
      }
    }
  });
  if (!visit) return null;
  return (
    <div className="flex-col w-full">
      {/* name of each tab group should be unique */}
      <div className="md:flex-row flex-col flex items-start mb-4">
        <h2 className="text-3xl">{visit["for"]}</h2>
        <div className="flex justify-between items-center gap-2 pt-2">
          <span className="badge badge-accent text-xs">{visit["type"]}</span>
          <span className="badge badge-accent text-xs">
            {visit["start_time"]} - {visit["finish_time"]}
          </span>

          <div className="p-2 bg-accent rounded-box text-accent-content text-xs">
            <span className="countdown font-mono text-accent-content">
              <span
                style={{
                  "--value": visitLength < 1 ? visitLength * 60 : visitLength,
                }}
                aria-live="polite"
                aria-label={""}
              >
                {visitLength < 1 ? 60 * visitLength : visitLength}
              </span>
            </span>
            {visitLength < 1 ? "min" : visitLength == 1 ? "hr" : "hrs"}
          </div>
        </div>
        <TimeFromStart
          attendance={attendance}
          key={JSON.stringify(attendance)}
        />
      </div>
      <div className="tabs tabs-box">
        <input
          type="radio"
          name="visit"
          className="tab"
          aria-label="Visit"
          defaultChecked
          // checked={tab == "visit"}
          // onClick={() => setTab("visit")}
        />
        <div className="tab-content ">
          <Attendance
            visit={visit}
            visitLength={visitLength}
            setVisitCompleted={setVisitCompleted}
            highlightNote={visit["highlight_note"]}
          />
        </div>
        <>
          <input
            type="radio"
            name="visit"
            className="tab"
            aria-label="Care Plans"
            // checked={tab == "careplan"}
            // onClick={() => setTab("careplan")}
          />
          <div className="tab-content ">
            <ClientPicker
              clients={clients}
              client={client}
              setClient={setClient}
            />
            <div className="divider">Care Plan</div>
            {carePlan ? (
              <>
                <ClientProfile carePlan={carePlan} />
                <CarePlan carePlan={carePlan} />
              </>
            ) : (
              <div role="alert" className="alert alert-warning">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 shrink-0 stroke-current"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span>No Care plan available</span>
              </div>
            )}
          </div>
          <input
            type="radio"
            name="visit"
            className="tab"
            aria-label="Tasks"
            disabled={visitCompleted}
            // checked={tab == "tasks"}
            // onClick={() => setTab("tasks")}
          />
          <div className="tab-content ">
            <ClientPicker
              clients={clients}
              client={client}
              setClient={setClient}
            />
            <div className="divider">Tasks</div>
            {client && visit["for_req_id"] && (
              <Tasks
                visit={visit}
                for_req_id={visit["for_req_id"]}
                clientId={client}
                type={visit["type"]}
              />
            )}
          </div>
          <input
            type="radio"
            name="visit"
            className="tab"
            aria-label="Body Map"
            // onClick={() => setTab("bodymap")}
            // checked={tab == "bodymap"}
          />
          <div className="tab-content ">
            <ClientPicker
              clients={clients}
              client={client}
              setClient={setClient}
            />

            <div className="divider">Body Map</div>
            <BodyMapForm
              clientId={client}
              visitId={visitId}
              type={visit["type"]}
            />
            {client && <BodyMapLogs client={client} />}
          </div>
          <>
            <input
              type="radio"
              name="visit"
              className="tab"
              aria-label="Record a Log"
              // checked={tab == "activities"}
              // onClick={() => setTab("activities")}
            />
            <div className="tab-content ">
              <ClientPicker
                clients={clients}
                client={client}
                setClient={setClient}
              />

              <div className="divider">Record a Log</div>
              <ActivityForm
                clientId={client}
                visitId={visitId}
                type={visit["type"]}
              />
              {client && <ActivityLogs clientId={client} />}
            </div>
          </>

          <input
            type="radio"
            name="visit"
            className="tab"
            aria-label="Issues"
            // checked={tab == "issues"}
            // onClick={() => setTab("issues")}
          />
          <div className="tab-content ">
            <ClientPicker
              clients={clients}
              client={client}
              setClient={setClient}
            />
            <div className="divider">Issues to highlight</div>
            <IssueForm
              clientId={client}
              visitId={visitId}
              type={visit["type"]}
            />
            {client && (
              <IssueLogs
                key={JSON.stringify(client)}
                visitId={visitId}
                clientId={client}
              />
            )}
          </div>
          <input
            type="radio"
            name="visit"
            className="tab"
            aria-label="Forms"
            // checked={tab == "forms"}
            // onClick={() => setTab("forms")}
          />
          <div className="tab-content ">
            <ClientPicker
              clients={clients}
              client={client}
              setClient={setClient}
              needsPleaseSelect={false}
              property={property}
              setPropertySelected={setPropertySelected}
            />
            <div className="divider">Forms</div>

            <GenericForms
              key={propertySelected ? property : client}
              clientOrStaffID={propertySelected ? property : client}
              type={propertySelected ? "property" : "client"}
            />
            <FormResponses
              key={`responses ${propertySelected ? property["propid"] : client}`}
              clientOrStaffID={propertySelected ? property["propid"] : client}
              type={propertySelected ? "property" : "client"}
            />
          </div>
          <input
            type="radio"
            name="visit"
            className="tab"
            aria-label="Incidents"
            // checked={tab == "incidents"}
            // onClick={() => setTab("incidents")}
          />
          <div className="tab-content ">
            <ClientPicker
              clients={clients}
              client={client}
              setClient={setClient}
            />

            <div className="divider">Incidents</div>
            <IncidentForm
              clientId={client}
              visitId={visitId}
              type={visit["type"]}
            />
            {client && <IncidentLogs clientId={client} />}
          </div>

          <input
            type="radio"
            name="visit"
            className="tab"
            aria-label="Handover Notes"
            // checked={tab == "handover"}
            // onClick={() => setTab("handover")}
          />
          <div className="tab-content">
            <ClientPicker
              clients={clients}
              client={client}
              setClient={setClient}
            />
            <div className="divider">Handover Notes</div>
            <HandoverNotes
              key={`${visitId}${client}`}
              visitId={visitId}
              clientId={client}
            />
          </div>
          <input
            type="radio"
            name="visit"
            className="tab"
            aria-label="Risk Assessments"
            // checked={tab == "risks"}
            // onClick={() => setTab("risks")}
          />
          <div className="tab-content">
            <ClientPicker
              clients={clients}
              client={client}
              setClient={setClient}
            />

            <div className="divider">Risk Assessments</div>
            <RiskAssesments clientId={client} />
          </div>
          {(visit["type"] == "SL" || visit["type"] == "Com Out") && (
            <>
              <input
                type="radio"
                name="visit"
                className="tab"
                aria-label="Expenses"
                // checked={tab == "expenses"}
                // onClick={() => setTab("expenses")}
              />
              <div className="tab-content ">
                <ClientPicker
                  clients={clients}
                  client={client}
                  setClient={setClient}
                  needsPleaseSelect={false}
                  property={property}
                  setPropertySelected={setPropertySelected}
                />

                <div className="divider">Expenses</div>
                <ExpensesForm
                  clientId={client}
                  visitId={visitId}
                  property={propertySelected && property["propid"]}
                  type={visit["type"]}
                />
                <ExpenseLogs visitId={visitId} />
                {/* <ActivityLogs visitId={visitId} /> */}
              </div>
            </>
          )}
          <input
            type="radio"
            name="visit"
            className="tab"
            aria-label="Client Information"
          />
          <div className="tab-content ">
            <ClientPicker
              clients={clients}
              client={client}
              setClient={setClient}
              needsPleaseSelect={false}
              property={property}
              setPropertySelected={setPropertySelected}
            />

            <div className="divider">Client Information</div>
            <ClientInfo
              key={client}
              clients={clients}
              client={client}
              setClient={setClient}
              needsPleaseSelect={false}
              property={property}
              setPropertySelected={setPropertySelected}
              clientId={client}
              visitId={visitId}
              property={propertySelected && property["propid"]}
            />
          </div>
        </>
      </div>
      <div className="join grid grid-cols-3 my-5">
        {prevVisit && (
          <Link
            key={prevVisit}
            className="join-item btn btn-sm"
            to={`/visits/${prevVisit["id"]}/details`}
            reloadDocument={true}
          >
            « Previous Visit
          </Link>
        )}
        <Link className="join-item btn btn-sm" to={`/visits/`}>
          My Visits
        </Link>

        {nextVisit && (
          <Link
            key={JSON.stringify(nextVisit)}
            className="join-item btn btn-sm"
            to={`/visits/${nextVisit["id"]}/details`}
            reloadDocument={true}
          >
            Next Visit »
          </Link>
        )}
      </div>
    </div>
  );
}
